import { createReducer, ActionType } from 'typesafe-actions';
import * as actions from './featureAccess.action';
import { FeatureAccessState } from './type';

export const initialState: FeatureAccessState = {
	features: {
		CAPA_REPORT: false,
		ADVANCED_ANALYTICS: false,
		MESSAGE_BROADCAST: false,
		MULTI_LANGUAGE_SUPPORT: false,
		ISSUE_TRACKER: false,
		CUSTOMIZED_LOCALIZED_MARKETING: false,
		SALES_TARGET_TRACKER: false,
		TEAM_INSPECTION_CAPABILITIES: false,
		INSIGHTS_NOTIFICATIONS: false,
		DIGITAL_SELFIE_SIGNOFFS: false,
		INVENTORY_MANAGEMENT: false,
		INVENTORY_MANAGEMENT_APP: false,
		STOCK_AUDIT_MEDIA: false,
		DATA_EXPORT: false,
		ISSUE_TRACKER_ESCALATION: false,
		JOURNEY_PLAN: false,
		COMPETITOR_ANALYSIS: false,
		CUSTOMER_FEEDBACK: false,
		DASHBOARD_V2: false,
		OFFLINE_AUDIT: false,
		FEDERATED_AUTHENTICATION: false,
		IRF_SAT: false,
		LMS: false,
		LMS_QUIZ: false,
		ATTACHMENT_GALLERY: false,
		NIMBLY_LITE: false,
		WHATSAPP_NOTIFICATION: false,
		HEALTH_DASHBOARD: false,
		AUDITOR_NON_OPERATIONAL_DAYS: false,
		OPENAI_RECOMMENDATION: false,
		REPORTSHUB_V2: false,
		ISSUE_TRACKER_ATTACHMENT_PREVIEW: false,
		ISSUE_PDF_EXPORT: false,
		FILE_REPOSITORY: false,
		ENHANCED_CHECKLIST: false,
		BULK_OPERATIONS: false,
		SCHEDULED_BULK_OPERATIONS: false,
		USER_MANAGEMENT_V2: false,
		ISSUE_TRACKER_MOBILE_APP: false,
		OBJECT_DETECTION: false,
		ISSUE_APPROVAL: true,
		GENERIC_ISSUE: true,
		DYNAMIC_TRANSLATION: false,
		SHOW_PRIORITY_PICKER: false,
		NOTIFICATION_CENTER: false,
		AUTO_SAVE_ATTACHMENT_TO_PHONE_MEDIA: false,
		QUESTIONNAIRE_V1: false,
		QUESTIONNAIRE_V2: false,
		FEATURE_ACCESS_V2: false,
		CREATE_BULK_SCHEDULE: false,
		MODIFY_ISSUE_PRIORITY: false,
		PRIORITY_MAPPING: false,
		FORMULA_BUILDER: false,
		CATEGORY_ATTRIBUTES: false,
		QNR_SCORING_CONFIG: false,
		QNR_ISSUE_CONFIG: false,
		QNR_TEMPLATES: false,
		LMS_CUSTOM_GROUPS: false,
		EXPORT_JSON_REPORT_ON_SUBMIT_SYNC: false,
		AREA_MANAGER_ROLLING: false,
		HOME_PAGE: false,
		ATTACHMENT_GALLERY_V2: false,
		ASSET_TRACKER: false,
		SKIP_GEOFENCING: false,
		QC_DASHBOARD: false,
		QC_PERFORMANCE_TAB: false,
	},
	packageType: 'starter',
	isLoading: false,
	isLoaded: false,
	error: null,
	modalVisible: false,
	currentOrg: '',
};

export type FeatureAccessAction = ActionType<typeof actions>;
const featureAccessReducer = createReducer<FeatureAccessState, FeatureAccessAction>(initialState)
	.handleAction(actions.setPackageType, (state, action) => ({
		...state,
		packageType: action.payload.packageType,
	}))
	.handleAction(actions.fetchFeatureAccess.request, (state) => ({
		...state,
		isLoading: true,
	}))
	.handleAction(actions.fetchFeatureAccess.success, (state, action) => {
		return {
			...state,
			isLoading: false,
			isLoaded: true,
			features: action.payload.data,
			packageType: action.payload.packageType,
		};
	})
	.handleAction(actions.fetchFeatureAccess.failure, (state, action) => ({
		...state,
		isLoading: false,
		error: action.payload.error,
	}))
	.handleAction(actions.setOrganization, (state, action) => ({
		...state,
		currentOrg: action.payload.org,
	}))
	.handleAction(actions.showFeatureModal, (state) => ({
		...state,
		modalVisible: true,
	}))
	.handleAction(actions.dismissFeatureModal, (state) => ({
		...state,
		modalVisible: false,
	}))
	.handleAction(actions.resetFeatureAccess, () => initialState);

export { featureAccessReducer };
